import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import Navbar from "../../Components/Navbar";
import { Base_Uri } from "../../Constant/BaseUri";

const UserLoginHistory = () => {
  const [loginHistory, setLoginHistory] = useState([]);
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    employeeName: "",
    status: "",
  });

  const fetchLoginHistory = async () => {
    try {
      let data = sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
      const queryParams = new URLSearchParams(filters).toString();
      const response = await axios.get(
        `${Base_Uri}login-history?${queryParams}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoginHistory(response.data);
    } catch (error) {
      console.error("Error fetching login history:", error);
    }
  };

  useEffect(() => {
    fetchLoginHistory();
  }, []);

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleApplyFilters = () => {
    fetchLoginHistory();
  };

  const handleTodayFilter = () => {
  const today = new Date();

  const localDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  const localDate2 = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()+1).padStart(2, '0')}`;
//console.log(localDate,"l")
  setFilters({ ...filters, startDate: localDate, endDate: localDate2 });
  fetchLoginHistory();
};

  return (
    <>
      <Navbar />
      <Paper style={{ padding: "20px" }}>
        {/* <Typography variant="h6">User Login History</Typography> */}

        {/* Filters */}
        <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
          <TextField
            label="Start Date"
            type="date"
            name="startDate"
            value={filters.startDate}
            onChange={handleFilterChange}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End Date"
            type="date"
            name="endDate"
            value={filters.endDate}
            onChange={handleFilterChange}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Employee Name"
            name="employeeName"
            value={filters.employeeName}
            onChange={handleFilterChange}
          />
          <TextField
            label="Status"
            name="status"
            select
            value={filters.status}
            onChange={handleFilterChange}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="success">Success</MenuItem>
            <MenuItem value="failed">Failed</MenuItem>
          </TextField>
          <Button variant="contained" onClick={handleApplyFilters}>
            Apply Filters
          </Button>
          <Button variant="outlined" onClick={handleTodayFilter}>
            Today
          </Button>
        </div>

        {/* Table */}
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Employee Name</TableCell>
                <TableCell>Login Time</TableCell>
                {/* <TableCell>Logout Time</TableCell>
                <TableCell>Session Duration (mins)</TableCell> */}
                {/* <TableCell>IP Address</TableCell>
                <TableCell>Device Info</TableCell> */}
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loginHistory.map((history) => (
                <TableRow key={history._id}>
                  <TableCell>
                    {history.user_id?.full_name || "Unknown"}
                  </TableCell>
                  <TableCell>
                    {new Date(history.login_time).toLocaleString()}
                  </TableCell>
                  {/* <TableCell>
                    {history.logout_time
                      ? new Date(history.logout_time).toLocaleString()
                      : "Not click logout"}
                  </TableCell>
                  <TableCell>
                    {history.session_duration
                      ? `${history.session_duration} mins`
                      : "N/A"}
                  </TableCell> */}
                  {/* <TableCell>{history.ip_address}</TableCell>
                  <TableCell>{history.device_info}</TableCell> */}
                  <TableCell>{history.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};

export default UserLoginHistory;
